export default __webpack_public_path__ + "static/media/BRAMKA_OTWARTA.6b8f83c6.png";